<template>
<section class="mall-image-data">
    <div class="mall-image-container w">
        <div class="mall-image-title">数据产品<span>Data products</span></div>
        <div class="mall-image-header">
            <div class="mall-image-header-search">
                <el-input v-model="searchText" placeholder="请输入检索关键词"
                    @keyup.enter.native="searchDataByText"></el-input>
                <el-button type="primary" @click="searchDataByText">搜索</el-button>
                <el-link type="primary" :underline="false" @click="needAdvanced = !needAdvanced">
                    高级筛选<i class="el-icon-s-fold"></i></el-link>
            </div>
            <Transition name="stretch">
                <div class="mall-image-header-advanced" v-show="needAdvanced">
                    <el-divider direction="vertical"></el-divider>
                    <!-- <span>采集时间</span>
                    <el-date-picker v-model="searchDateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker> -->
                        <span style="margin-right: 10px;">所属区域 </span>
                        <citySingle @getCityInfo="getCityInfoFun" style="width: 100%;margin-right: 10px;">
					</citySingle>
                    <span>分辨率</span>
                    <el-select v-model="searchResolution">
                        <el-option v-for="item in resolutionOptions" :key="item.value"
                            :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-button type="primary" @click="advancedSearch">查询</el-button>
                    <el-button type="primary" plain @click="clearSearch">重置</el-button>
                </div>
            </Transition>
        </div>

        <div class="mall-image-content">
            <div class="mall-image-content-operate">
                <span>排序：</span>
                <el-link type="primary" :underline="false" @click="sortByPrice"
                    :class="{actived: sortType === 3 || sortType === 5}">价格
                    <i :class="[this.sortType === 3 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
                <el-link type="primary" @click="sortBySales" :underline="false"
                    :class="{actived: sortType === 2 || sortType === 7}">销量
                    <i :class="[this.sortType === 2 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
                <el-link type="primary" @click="sortByCreate" :underline="false"
                    :class="{actived: sortType === 4 || sortType === 8}">新品
                    <i :class="[this.sortType === 4 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
                <el-link type="primary" @click="sortByComment" :underline="false"
                    :class="{actived: sortType === 1 || sortType === 6}">评论量
                    <i :class="[this.sortType === 1 ? 'el-icon-top':'el-icon-bottom']"></i></el-link>
            </div>
            <div class="mall-image-goods">
                <GoodsCardForDataPro v-for="item in dataProduct" :data="item"></GoodsCardForDataPro>

                <el-empty description="暂无其他类型的产品" v-if="!dataProduct.length"></el-empty>
            </div>
            <el-pagination :current-page.sync="currentPage" @current-change="getGoodsData"
                :page-size="12" layout="total, prev, pager, next" :total="dataSum"></el-pagination>
        </div>
    </div>
    <CategorySwitch></CategorySwitch>
</section>
</template>

<script>
import GoodsCardForDataPro from '../../../components/RemoteSensingMall/GoodsCardForDataPro.vue'
import CategorySwitch from '../../../components/RemoteSensingMall/CategorySwitch.vue'
import citySingle from "@/components/citySingle.vue";

export default {
    name: 'DataProduct',
    components: {
        GoodsCardForDataPro, CategorySwitch,citySingle
    },
    data() {
        return {
            searchText: null,
            needAdvanced: false,
            searchDateRange: null,
            searchResolution: 0,
            resolutionOptions: [
                {label: '全选', value: 0},
                {label: '优于亚米', value: 1},
                {label: '1m-2m', value: 2},
                {label: '2m-5m', value: 3},
                {label: '5m-10m', value: 4},
                {label: '10m-30m', value: 5},
                {label: '大于30米', value: 6}
            ],
            sortType: 4,
            dataProduct: [],
            currentPage: 1,
            dataSum: 0,
            Myform:{
                countryId:'',
                provinceId:'',
                cityId:'',
                countyId:'',
            }
        }
    },
    mounted() {
        this.getGoodsData()
    },
    computed: {

    },
    methods: {
        	// 获取省市区信息
		getCityInfoFun(value) {
			console.log('获取省市区信息', value);
			this.Myform.countryId = value[0];
			this.Myform.provinceId = value[1];
			this.Myform.cityId = value[2];
			this.Myform.countyId = value[3];
		},
        getGoodsData() {
            this.$http.post(this.$const.RemoteSensingMall.requestGoodsPageDatas, {
                pageNum: this.currentPage,
                pageSize: 12,
                goodsCategory: 2,
                keyword: this.searchText,
                orderType: this.sortType,
                resolutionRatio: this.searchResolution,
                beginTime: this.searchDateRange ? this.searchDateRange[0] : null,
                endTime: this.searchDateRange ? this.searchDateRange[1] : null,
                countryId:this.Myform.countryId,
                provinceId:this.Myform.provinceId,
                cityId:this.Myform.cityId,
                countyId:this.Myform.countyId,
            }).then(res => {
                if(res.code === 200) {
                    this.dataSum = res.data.total
                    this.dataProduct = res.data.list
                }
            }).catch(error => {
                console.log(error)
            })
        },
        searchDataByText() {
            this.currentPage = 1
            this.getGoodsData()
        },
        advancedSearch() {
            this.currentPage = 1
            this.getGoodsData()
        },
        clearSearch() {
            this.searchText = null
            this.searchDateRange = null
            this.searchResolution = 0
        },
        sortByPrice() {
            if(this.sortType === 3) { this.sortType = 5}
            else { this.sortType = 3}
            this.getGoodsData()
        },
        sortBySales() {
            if(this.sortType === 2) { this.sortType = 7}
            else { this.sortType = 2}
            this.getGoodsData()
        },
        sortByCreate() {
            if(this.sortType === 4) { this.sortType = 8}
            else { this.sortType = 4}
            this.getGoodsData()
        },
        sortByComment() {
            if(this.sortType === 1) { this.sortType = 6}
            else { this.sortType = 1}
            this.getGoodsData()
        },
    }
}
</script>

<style lang="scss" scoped>
.mall-image-data {
    position: relative;
    width: 100%;
    background-color: #F5F5F5;

    >.mall-image-container {
        display: flex;
        flex-direction: column;

        >.mall-image-title {
            padding: 30px 0;
            padding-left: 12px;
            color: #2569F2;
            font-size: 24px;
            font-weight: 700;

            >span {
                margin-left: 20px;
                color: #798AAC;
                font-size: 16px;
            }
        }

        >.mall-image-header {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: fit-content;
            margin-bottom: 32px;
            padding: 20px;
            border-radius: 6px;
            background-color: white;

            ::v-deep input {
                background-color: #F5F5F5;
            }

            >.mall-image-header-search {
                display: flex;
                align-items: center;

                >button {
                    margin-left: 10px;
                }

                > a {
                    margin-left: 20px;
                    font-size: 14px;
                    white-space: nowrap;
                    user-select: none;

                    i {
                        margin-left: 6px;
                    }
                }
            }

            >.mall-image-header-advanced {
                display: flex;
                align-items: center;

                >.el-divider {
                    margin: 0 20px;
                }

                >span {
                    font-size: 14px;
                    font-weight: 700;
                    white-space: nowrap;
                }

                >.el-date-editor {
                    margin: 0 20px;
                    background-color: #F5F5F5;

                    > ::v-deep .el-range-separator {
                        margin-left: -12px;
                        width: 6%;
                    }
                }
                > .el-select{
                    margin: 0 20px;
                }
            }
        }

        > .mall-image-content{
            display: flex;
            flex-direction: column;

            > .mall-image-content-operate{
                display: flex;
                align-items: center;
                padding: 0 12px;

                > span {
                    margin-right: 40px;
                    font-size: 14px;
                    font-weight: 700;
                }
                > a {
                    margin: 0 30px;
                    padding: 5px 10px;
                    transition: .3s;
                    user-select: none;

                    &.actived {
                        background-color: rgba($color: #2569F2, $alpha: .15);
                        border: 1px solid #2569F2;
                        border-radius: 3px;
                    }
                    i {
                        margin-left: 6px;
                    }
                }
            }
            > .mall-image-goods{
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;

                > div {
                    flex: 0 0 25%;

                    @media (max-width: 1024px) { flex: 0 0 33%;}
                }
                > .el-empty {
					margin: 0 auto;
				}
            }
            > ::v-deep .el-pagination{
                margin: 60px 0;

                > button {
                    width: 35px;
                    height: 35px;
                    padding: 0;
                    background-color: transparent;
                    border-radius: 6px;
                }
                > ul {
                    margin: 0 6px;

                    > li {
                        width: 35px;
                        height: 35px;
                        margin: 0 6px;
                        background-color: transparent;
                        border-radius: 6px;
                        line-height: 35px;
                        transition: .2s;

                        &:hover {
							color: #2569F2;
						}
						&.active {
							color: white;
							background-color: #2569F2;

							&:hover {
								color: white;
							}
						}
                    }
                }
            }
        }
    }
}
// 动画
.stretch-enter-active, .stretch-leave-active{
    transition: .2s;
}
.stretch-enter, .stretch-leave-to {
    opacity: 0;
}
</style>